import subDays from "date-fns/subDays";
import endOfDay from "date-fns/endOfDay";
import { observable } from "mobx";
import { Type } from "class-transformer";
import { startOfEDAZ } from "../config";
import type { EntityValidationRules } from "../services/validationService";
import { startOfCzechDay } from "../utils/dateUtils";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AdHocReportRequest {
  @observable
  @Type(() => Date)
  fromDate!: Date;

  @observable
  @Type(() => Date)
  toDate!: Date;

  @observable
  forceRequest?: boolean;
}

export class AdHocReportFile {
  @observable
  downloadFileName: string;

  @observable
  fileUrl: string;

  @observable
  contentType: string;

  @observable
  contentLength: number;
}

export const AdHocReportRequestValidationRules: EntityValidationRules<AdHocReportRequest> = {
  fromDate: {
    required: true,
    isBefore: {
      condition: (entity: AdHocReportRequest) => entity.toDate,
    },
    isAfter: {
      after: endOfDay(subDays(startOfEDAZ, 1)),
    },
  },
  toDate: {
    required: true,
    isBefore: {
      before: startOfCzechDay(),
    },
    isAfter: {
      condition: (entity: AdHocReportRequest) => entity.fromDate,
    },
  },
};
